// Generated by scripts/build-ui-icons.mjs.
export { CaretDown as default } from "../ui/glyphs-2";
